import { ReactElement } from 'react';
import { generatePath, Route } from 'react-router-dom';

import { createRouteConfig } from 'modules/common/utils/createRouteConfig';
import { DeFi } from 'modules/defi/screens/DeFi';

const PATH = '/defi';

export const DeFiRoutesConfig = createRouteConfig(
  {
    defi: {
      path: PATH,
      generatePath: () => generatePath(PATH),
    },
  },
  PATH,
);

export function getDeFiRoutes(): ReactElement {
  return <Route element={<DeFi />} path={DeFiRoutesConfig.defi.path} />;
}
